export default __webpack_public_path__ + "f74a68eccc210532cffc9b6d6ab171c0.webp";